module.exports = __webpack_public_path__ + "img/5.e97cbba9.png";